import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import SvgIcon from 'material-ui/SvgIcon';
import Snackbar from 'material-ui/Snackbar';


import { updateUser, getSingleUser } from '../../actions/userActions';
import LoadingState from '../Loading';

import {
  Container,
  FormContainer,
  FormGroup,
  FormTitle,
  Pre,
  Code
} from '../Styles/index';

class UserForm extends Component {

  state = {
    name: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    active: false,
    openSnackBar: false,
    hasError: false,
    credit: 0,
    debit: 0,
    updatedAt: ''

  }

  _handleChange = (event) => {
      return this.setState({
        [event.target.name]: event.target.value
      });
  }

  _handleBlur = event => {
    switch (event.target.name) {
      case 'credit':
        return this.setState({
          [event.target.name]: event.target.value ? parseFloat(event.target.value) : 0
        });
      case 'debit':
        return this.setState({
          [event.target.name]: event.target.value ? parseFloat(event.target.value) : 0
        });
      default:
        return this.setState({
          [event.target.name]: event.target.value
        });
    }
  }

  _handleCheck = (event, checked) => {
    this.setState({
      [event.target.name]: checked
    });
  }

  _handleSubmit = event => {
    event.preventDefault();

    console.log(this._formatFormData());
    this.props.updateUser({
      userData: this._formatFormData(),
      username: this.state.usernameParam
    }).then(res => {
      this.setState({
        openSnackBar: this.props.user && this.props.user.status === 'updated',
      })
      if (this.props.user && this.props.user.status === 'updated') {
        this.props.getSingleUser({ username: this.state.username || this.state.usernameParam })
        .then(res => {
          if (this.props.userToEdit.status === 'fetched') {
            this._handleNewData();
          }
        })
      }
    })

  }

  _handleClearInput = event => {
    this.setState({
      name: '',
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      active: false,
      openSnackBar: false,
      hasError: false,
      credit: 0,
      debit: 0,
      updatedAt: ''
    })
  }

  get balance() {
    const { balance } = this.props.userToEdit.user
    
    if (!balance) {
      return {
        credit: 0,
        debit: 0,
        updatedAt: null
      }
    }
    const _balance = {...balance}
    if (!_balance.credit) {
      _balance.credit = 0
    }
    if (!_balance.debit) {
      _balance.debit = 0
    }

    // _balance.updatedAt = moment(balance.updatedAt, "DD/MM/YYYY").toDate() //moment(balance.updatedAt).format()

    return _balance
  }

  _handleNewData(){ 

    this.setState({
      name: this.props.userToEdit.user.name,
      username: this.props.userToEdit.user.username,
      email: this.props.userToEdit.user.email,
      password: '',
      confirmPassword: '',
      active: this.props.userToEdit.user.active,
      hasError: false,
      ...this.balance
    });
    if (this.state.usernameParam !== this.props.userToEdit.user.username) {
      this.setState({
        usernameParam: this.props.userToEdit.user.username
      })

      this.props.history.push(`/users/edit?user=${this.props.userToEdit.user.username}`);
    }
  }

  _handleRequestClose = () => {
    this.setState({
      openSnackBar: false,
    });
  }

  _formatFormData(){
    const data = {
      name: this.state.name,
      username: this.state.username,
      email: this.state.email,
      password: this.state.password,
      active: this.state.active ? 'active' : 'not-active',
      balance: {
        credit: this.state.credit,
        debit: this.state.debit,
        updatedAt: this.state.updatedAt,
      }
    }

    for (const key in data) {
      if (data.hasOwnProperty(key)) {

        if (
          (typeof data[key] !== 'boolean' && typeof data[key] !== 'number' && typeof data[key] !== 'object') && 
          (data[key].trim() === '' || data[key] === null || data[key] === undefined)
        ) {
          // console.log(data[key].trim());
          delete data[key];
        }
      }
    }

    return data;
  }

  componentDidUpdate() {

  }

  componentWillMount() {
    const parsedQuery = queryString.parse(this.props.location.search);
    const username = parsedQuery.user;

    this.props.getSingleUser({username})
      .then(res => {
        if (this.props.userToEdit.status === 'fetched'){
          this.setState({
            name: this.props.userToEdit.user.name,
            username: this.props.userToEdit.user.username,
            email: this.props.userToEdit.user.email,
            active: this.props.userToEdit.user.active,
            usernameParam: username,
            ...this.balance,            
          })
        }
      });
  }

  componentDidMount() {
  }


  render() {
    return (
      <div>
      {this.props.userToEdit.loading 
        ? <LoadingState/>
        : <div>
          <form onSubmit={this._handleSubmit}>
          <Container>
            <FormContainer >
              <FormGroup>
                <FormTitle>Edit User</FormTitle>
              </FormGroup>
              <FormGroup>
                <TextField
                  fullWidth
                  id="name"
                  name="name"
                  floatingLabelText="Name"
                  value={this.state.name}
                  onChange={this._handleChange}
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  fullWidth
                  id="username"
                  name="username"
                  floatingLabelText="Username"
                  value={this.state.username}
                  onChange={this._handleChange}
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  type="email"
                  floatingLabelText="Email"
                  value={this.state.email}
                  onChange={this._handleChange}
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  fullWidth
                  type="password"
                  id="password"
                  name="password"
                  floatingLabelText="Password"
                  value={this.state.password}
                  onChange={this._handleChange}
                />
                <IconButton tooltip="Password is required" style={{position: 'absolute', right: '0', bottom: '16px'}}>
                  <SvgIcon >
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                  </SvgIcon>
                </IconButton>
              </FormGroup>
              <FormGroup>
                <TextField
                  fullWidth
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  floatingLabelText="Confirm Password"
                  value={this.state.confirmPassword}
                  onChange={this._handleChange}
                />
              </FormGroup>
              <FormGroup style={{ background: '#f6f6f9', borderRadius: '4px', padding: '8px 16px'}}>
                <div style={{padding: '8px 0'}}>Financa</div>
                <TextField
                  required
                  id="debit"
                  name="debit"
                  type="text"
                  floatingLabelText="Debit"
                  value={this.state.debit}
                  onChange={this._handleChange}
                  onBlur={this._handleBlur}
                  style={{marginRight: '16px'}}
                />
                <TextField
                  required
                  id="credit"
                  name="credit"
                  type="text"
                  floatingLabelText="Credit"
                  value={this.state.credit}
                  onChange={this._handleChange}
                  onBlur={this._handleBlur}
                />
                <TextField 
                  required
                  id="updatedAt"
                  name="updatedAt"
                  type="text"
                  floatingLabelText="Updated At" 
                  value={this.state.updatedAt}
                  onChange={this._handleChange}
                  onBlur={this._handleBlur}
                />
              </FormGroup>
              <FormGroup>
                <Checkbox
                  label="is Active"
                  id="active"
                  name="active"
                  checked={this.state.active}
                  onCheck={this._handleCheck}
                />
              </FormGroup>
              <FormGroup >
                <RaisedButton type='submit' label="Update" primary={true} />
                <RaisedButton style={{marginLeft: '16px'}} label="Remove" labelStyle={{color: 'white'}}  backgroundColor="#F44336" onTouchTap={this._handleClearInput}/>
              </FormGroup>
              <Snackbar
                open={this.state.openSnackBar}
                message="User updated successfully!"
                autoHideDuration={3000}
                onRequestClose={this._handleRequestClose}
              />
              {this.props.user && this.props.user.status === 'not-updated' &&
                <FormGroup>
                  <Pre>
                    <Code>
                      {`${JSON.stringify(this.props.user.error, undefined, 2)}`}
                    </Code>
                  </Pre>
                </FormGroup>
              }
            </FormContainer>
          </Container>
          </form>
          </div>
        }
      </div>
    );
  }
}




const mapStateToProps = state => ({ user: state.user.updated, userToEdit: state.users.userToEdit });
const mapDispatchToProps = { updateUser, getSingleUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserForm));


// WEBPACK FOOTER //
// ./src/components/Users/UserFormEdit.js